import styled from "styled-components";

export const StyledPayment = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
`;

export const StyledWithAddress = styled.div<{ isReviewStep: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ isReviewStep }) => (isReviewStep ? "20px" : "10px")};
`;

export const StyledText = styled.div`
  font-size: 13px;
`;

export const StyledBoldText = styled.span`
  font-weight: 700;
`;
